// CellularBadge — discreet connectivity chip that surfaces only when offline.
//
// Shows nothing when online (clean cockpit). When offline, shows a small
// amber chip: "offline since HH:MM" so the pilot always knows if data is
// potentially stale.
//
// Pair with PublicationsBadge — both sit at the bottom of the SideRail.

import { useConnectivityStore, connectivityLabel } from '../stores/connectivityStore';

export default function CellularBadge() {
  const online = useConnectivityStore((s) => s.online);
  const store = useConnectivityStore();

  // Silent when online — don't clutter the rail with a happy-path chip.
  if (online) return null;

  return (
    <div
      title="Network unavailable — map layers and weather are using cached data"
      className="flex items-center gap-1 rounded-md border border-amber-600 px-2 py-1 text-[10px] bg-amber-900/30 text-amber-400 font-medium"
    >
      <span>📵</span>
      <span className="hidden sm:inline">{connectivityLabel(store)}</span>
    </div>
  );
}
